
import React, { FormEvent } from "react";
import { HttpsRequest, GetAuth, Alerts } from '../component/Utils';
import MenuComp, { PageTitle } from "../component/menucomp";
import { URLENUM } from "../component/Texts";
import { Loading, ActionBar, BoxArea } from "../component/BaseComponent";
import { MSG } from "../component/Texts";
import { FormGroup } from '../component/form';
import { APIRoute, RespStatus } from "../component/texts";



type SettingProp = {
}

type SettingState = {
    isbusy: boolean;
    body: Record<string, unknown>[];
    pager: PagerType,
    form: Record<string, number | string | unknown>[];
    data: Record<string, number | string | unknown>;
    split: boolean;
    show_logo:boolean;
    logo_url?:string;
}

class UserSetting extends React.Component<SettingProp, SettingState> {

    constructor(props: SettingProp) {

        super(props);

        this.state = {
            isbusy: true,
            body: [],
            pager: {
                next_page: 0,
                page: 1,
                pages: [],
                prev_page: 0,
                total: 0,
                rows: 10
            },
            form: [],
            data: {},
            split: false,
            show_logo: false,
            logo_url: '',
        }
   
    }

   

    render() {

        return (
            <>
                <MenuComp />
                <br/>
                <br/>

                {
                    this.state.form.length === 1? (
                        <ActionBar
                            classname={this.state.split ? "col-md-6" : "col-md-8"}
                            placeholder={"search"}
                            search={false}
                            btnfunc={(e) =>{e.preventDefault(); Alerts.show_success(MSG.UPGRADE_MSG) }}
                            btntitle={"Upgrade Plan"}
                        />
                    ) : (
                        <ActionBar
                            classname={this.state.split ? "col-md-6" : "col-md-8"}
                            placeholder={"search"}
                            search={false}
                            btnfunc={(e)=>{ e.preventDefault(); this.open_form_editor()}}
                            btntitle={"Edit Settings"}
                        />
                    )
                }
                                              
                <br />
                <div className="container-fluid">
                    <div className="row">
                        <BoxArea classname={this.state.split ? "col-md-6" : "col-md-8"}>
                            <PageTitle title={"User Settings"} />
                            <div className="table-responsive">
                                <table className="table table-condensed table-hover table-striped">
                                    <tbody> 
                                        {this.state.show_logo? (
                                            <tr>
                                                <th> Company Logo </th>
                                                <td> 
                                                    <div className={'d-flex flex-row'}>
                                                        <img src={this.state.logo_url} style={{width: "100px", height: '100px'}} />    
                                                        <div className={'mx-3 justify-content-end align-content-end'}>
                                                            <button className='btn btn-sm btn-info'> Change Company Logo </button>
                                                        </div>

                                                    </div>
                                                </td>
                                            </tr>

                                        ) : null }
                                        
                                        
                                        {
                                            this.state.body.map((itm, idx) =><SettingRow
                                                key={`st${idx}`}
                                                item={itm as any}
                                            />
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </BoxArea>
                        {
                            this.state.split ? (
                                <BoxArea classname="col-md-6 posrel">

                                    <PageTitle title={'Modify Settings'} />
                                    <div>
                                        <form method='post'
                                            autoComplete="off" 
                                            onSubmit={this.post_setting_data}
                                            
                                        >

                                            {
                                                this.state.form.map((fld, idx) => {
                                                    return <FormGroup
                                                        key={`tm-${idx}`}
                                                        obj={fld} onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                            this.onchange(e);
                                                        }}
                                                        onselectchange={this.onchange}
                                                    />;
                                                })
                                            }

                                            <div className="mb-4 mt-4 padv5">
                                                <div className="form-group row">
                                                    <div className="d-flex justify-content-around">
                                                        <div className="d-grid gap-2 col-3">
                                                            <button type="submit" className="btn btn-primary btn-lg">
                                                                Save
                                                            </button>
                                                        </div>
                                                        <div className="d-grid gap-2 col-3">
                                                            <button type="button" onClick={() => this.setState({ split: false })} className="btn btn-light btn-lg">
                                                                &nbsp;&nbsp; Cancel &nbsp;&nbsp;
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    {this.state.isbusy && <Loading/>}
                                    </div>

                                </BoxArea>
                            ) : null
                        }
                    </div>

                </div>
                
                { this.state.isbusy && <Loading />}
                <style>
                    {`
                        table tr > td , table tr > th {                    
                            font-size: 20px; 
                            font-weight: 400;
                        }
                        table tr > th {
                            font-weight: 500;
                        }
                    `}
                </style>

            </>
        )
    }

    load_function = (resp: callbackType) => {

        if (resp.status !== 0) {
        
            Alerts.show_error(resp.errormsg!);
            this.setState({
                isbusy: false
            })
        
            return
        }
 
        
        this.setState({
            isbusy: false,
            body: resp.body.setting_data,
            form: resp.body.form,
            data: resp.body.edit_init_data,
            show_logo:resp.body.show_logo,
            logo_url: resp.body.logo_url 
        });

    }

    componentDidMount() {
        HttpsRequest.get(
            URLENUM.settings, 
            this.load_function, 
            GetAuth()
        );
    }

    open_form_editor = () => {  
        this.setState({split: true});

    }

    onchange = (event: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => {
 
        const {data} = this.state ; 

        data[event.target.name] = event.target.value; 

        if (event.target.name === 'company_logo'){
            const _file = (event.target as HTMLInputElement).files;
            data[event.target.name] = _file![0];           
        }
 
        if (event.target.type === 'checkbox'){

            if ((event.target as HTMLInputElement).checked === true){
                data[event.target.name] = 1
            } else {
                data[event.target.name] = 0
            } 
        }
  
        this.setState({
            data
        })

    }

    post_setting_data = (event: FormEvent<HTMLFormElement>) => {

        event.preventDefault();     
        
        const data = {...this.state.data}

        HttpsRequest.postfile(APIRoute.update_setting, 
            this.state.data, this.post_setting_cb, 
            GetAuth(),             
            (resp:RespArgs)=>this.setState({isbusy: false})
        )
        this.setState({isbusy:true})

    }

    post_setting_cb = (resp:RespArgs) => {

        if (resp.status == RespStatus.success){
            this.setState({split: false, form: []})
            HttpsRequest.get(
                URLENUM.settings, 
                this.load_function, 
                GetAuth(), {},
                (resp:RespArgs) => this.setState({isbusy: false})
            );
        }
        else {
            this.setState({
                isbusy: false,
                form: resp.body.form
            })
        }


    }
}

function SettingRow({ item }: { item: Array<string|any>}) {

 
    if (item[0].length == 0) return null

    if (item[0] === 'Company Logo'){

        return (
            <tr>
                <th> {item[0]}: </th>
                <td> <div dangerouslySetInnerHTML={{__html: item[1] }}></div> </td>
            </tr>
        )
    }

    return (
        <tr>
            <th> {item[0]}: </th>
            <td> {item[1]} </td>
        </tr>
    )
}

export default UserSetting